import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useUser } from '../../context/UserContext';

/**
 * Garde "admin" — usable après RequireAuth uniquement (suppose user défini).
 * Si l'utilisateur n'est pas admin, redirection vers la racine.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user } = useUser();
  if (user === undefined) return null;
  if (user === null || user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
